import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { Attendance } from "@/@types/esus/Attendance";

type IndicatorEmultiM2AttendanceHistoryItemProps = {
	attendance: Attendance;
};

export function IndicatorEmultiM2AttendanceHistoryItem({
	attendance,
}: Readonly<IndicatorEmultiM2AttendanceHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{attendance.healthTeam?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{attendance.healthUnit?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{attendance.professional1?.name.toUpperCase() ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{attendance.cbo1?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>

			{attendance.healthTeam2 &&
				attendance.healthTeam2.id !== 1 &&
				attendance.healthUnit2 &&
				attendance.healthUnit2.id !== 1 &&
				attendance.professional2 &&
				attendance.professional2.id !== 1 &&
				attendance.cbo2 &&
				attendance.cbo2.id !== 1 && (
					<>
						<Row>
							<Col>
								<p>
									<span className="fw-bold text-primary">
										Equipe secundária:{" "}
									</span>
									{attendance.healthTeam2?.name.toUpperCase() ?? "N/A"}
								</p>
							</Col>
							<Col>
								<p>
									<span className="fw-bold text-primary">
										Unidade secundária:{" "}
									</span>
									{attendance.healthUnit2?.name.toUpperCase() ?? "N/A"}
								</p>
							</Col>
						</Row>
						<Row>
							<Col>
								<p>
									<span className="text-primary">Profissional secundário: </span>
									{attendance.professional2?.name.toUpperCase() ?? "N/A"}
								</p>
							</Col>
							<Col>
								<p>
									<span className="text-primary">
										Categoria do profissional secundário:{" "}
									</span>
									{attendance.cbo2?.description?.toUpperCase() ?? "N/A"}
								</p>
							</Col>
						</Row>
					</>
				)}

			{(attendance.weight || attendance.height) && (
				<Row>
					<Col>
						<p>
							<span className="fw-bold text-primary">Peso: </span>
							{`${attendance.weight ? `${attendance.weight}KG` : "N/A"}`}
						</p>
					</Col>
					<Col>
						<p>
							<span className="fw-bold text-primary">Altura: </span>
							{`${attendance.height ? `${attendance.height}CM` : "N/A"}`}
						</p>
					</Col>
				</Row>
			)}
		</>
	);
}
